export enum AssementType {
  empty,
  personal,
}
